export const matchesPattern = (uid: string, pattern: string): boolean => {
  if (pattern.endsWith('*')) {
    return uid.startsWith(pattern.slice(0, -1))
  }

  return uid === pattern
}

export const matchesAnyPattern = (uid: string, patterns: string[]): boolean =>
  patterns.some((p) => matchesPattern(uid, p))

export const parsePatterns = (patterns?: string | null): string[] =>
  patterns
    ? patterns
        .split(',')
        .map((p) => p.trim())
        .filter(Boolean)
    : []
